import { Button } from '@convergence/components';
import { cva } from 'class-variance-authority';
import { Link } from 'react-router-dom';

const TIER_TITLES = {
  FREE: 'Free',
  // PREMIUM: 'Premium',
  LAB: 'Lab'
} as const;

const TIER_PRICES = {
  FREE: '$0/month',
  // PREMIUM: '$10/month',
  LAB: 'Price depends on lab size'
} as const;

const TIER_FEATURES = {
  FREE: ['1 Tinkerbox', '32GB Storage', '40hrs/month'],
  // PREMIUM: ['10 Tinkerboxes (no limit)', 'Unlimited Storage'],
  LAB: ['Multiple TinkerBoxes',
    'Lab Access',
    "No time limit",
    "Increased storage",
    "Bring your own samples",
    "Collaborative environment",
    "SSH access",
    "Support"
  ]
} as const;

const TIER_LINKS = {
  FREE: null,
  // PREMIUM: (
  //   <Link to="/checkout">
  //     <Button className='text-2xl px-12'>Select</Button>
  //   </Link>
  // ),
  LAB: (
    <Link to="/contact">
      <Button className='text-xl px-12'>Contact Us</Button>
    </Link>
  )
} as const;

const tiers = [
  {
    title: TIER_TITLES.FREE,
    price: TIER_PRICES.FREE,
    features: TIER_FEATURES.FREE,
    link: TIER_LINKS.FREE
  },
  {
    title: TIER_TITLES.LAB,
    price: TIER_PRICES.LAB,
    features: TIER_FEATURES.LAB,
    link: TIER_LINKS.LAB
  }
] as const;

const styles = cva(
  [
    'w-96',
    'h-1/2',
    'p-4',
    'flex',
    'flex-col',
    'justify-evenly',
    'bg-white',
    'border-black',
    'border',
    'lowercase',
  ],
  {
    variants: {
      tier: {
        Free: '',
        // Premium: 'shadow-lg shadow-neutral-500 scale-110 z-1000 text-orange-2 border-orange-2',
        Lab: ''
      }
    }
  }
);

type DetailType = typeof tiers[number];

export function Pricing() {
  return (
    <div className="w-full h-full flex justify-center items-center gap-2 bg-white">
      {tiers.map((tier) => (
        <Tier tier={tier} />
      ))}
    </div>
  );
}

function Tier(props: { tier: DetailType }) {
  return (
    <div className={styles({ tier: props.tier.title })}>
      <header>
        <h1 className="text-2xl font-bold">{props.tier.title}</h1>
        <h2 className="text-4xl font-bold">{props.tier.price}</h2>
      </header>
      <ul className="flex gap-1 pl-2 flex-col text-xl">
        {props.tier.features.map((feature) => (
          <li>{feature}</li>
        ))}
      </ul>
      {props.tier.link && props.tier.link}
    </div>
  );
}
